<template>
	<div class="mb-4">
		<Sections></Sections>
	</div>
</template>

<script>
import Sections from '../Widgets/Risks/Sections.vue';
export default {
	name: 'Risks',
	components: {
		Sections
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>